import { STALE_TIME_L } from "#app/http/ReactQueryProvider";
import { searchQuoteRequestLineSimilarParts } from "#modules/similarPart/infra/searchQuoteRequestLineSimilarParts.api";
import { queryKeys } from "#shared/queryKeys/queryKeys";
import { FilterQuery } from "shared";

export const searchQuoteRequestLineSimilarPartsQuery = (
  id: string | undefined,
  filterParams: FilterQuery,
  limit = 9,
) => ({
  queryKey: queryKeys.searchQuoteRequestLineSimilarParts.detail(id, limit, filterParams),
  queryFn: () => searchQuoteRequestLineSimilarParts({ id, filterParams, limit }),
  staleTime: STALE_TIME_L,
  enabled: !!id,
});
